import Button from './Button';
import GameData from './GameData';
import AudioManager from './AudioManager';

const buttons = [];

/**
 * @class TurboButton
 * @classdesc TurboButton contains all business logic and event handling code
 * for turbo button which controls turbo mode feature
 */
class TurboButton extends Button {
    constructor(path, x = 0, y = 0, scale, checkingProp, clickAction = () => { /* empty */ }) {
        super(path, x, y, scale);

        this.clickAction = clickAction;
        this.checkingProp = checkingProp;
        this.isTurboChecked = GameData.getProperty(this.checkingProp);
        buttons.push(this);
    }

    switchState() {
        if (GameData.getProperty(this.checkingProp)) {
            this.switchOff();
        } else {
            this.switchOn();
        }
        this.clickAction();
    }

    disable() {
        if (!GameData.getProperty(this.checkingProp)) {
            this.gotoAndStop(2);
        } else {
            this.gotoAndStop(6);
        }
        this.isDisabled = true;
    }

    enable() {
        if (!GameData.getProperty(this.checkingProp)) {
            this.gotoAndStop(0);
        } else {
            this.gotoAndStop(4);
        }
        this.isDisabled = false;
    }

    switchOn() {
        this.gotoAndStop(4);
        GameData.setProperty(this.checkingProp, true);
    }

    switchOff() {
        this.gotoAndStop(0);
        GameData.setProperty(this.checkingProp, false);
    }

    _initMobile() {
        this.on('pointerdown', (e) => {
            if (this.isDisabled) {
                return;
            }
            if (!GameData.getProperty(this.checkingProp)) {
                this.gotoAndStop(3);
            } else {
                this.gotoAndStop(7);
            }
            AudioManager.playSound('fx', 'btns');
            this.switchState();
        });

        this.on('pointerupoutside', () => {
            if (this.isDisabled) {
                return;
            }
            if (!GameData.getProperty(this.checkingProp)) {
                this.gotoAndStop(0);
            } else {
                this.gotoAndStop(4);
            }
        });

        this.on('pointerup', () => {
            if (this.isDisabled) {
                return;
            }
            if (!GameData.getProperty(this.checkingProp)) {
                this.gotoAndStop(0);
            } else {
                this.gotoAndStop(4);
            }
        });

        if (this.isTurboChecked) {
            this.switchOn();
        } else {
            this.switchOff();
        }
    }

    _init() {
        this.on('pointerclick', () => {
            if (this.isDisabled) {
                return;
            }
            AudioManager.playSound('fx', 'btns');
            this.switchState();
        });

        this.on('pointerover', () => {
            if (this.isDisabled) {
                return;
            }

            if (!GameData.getProperty(this.checkingProp)) {
                this.gotoAndStop(1);
            } else {
                this.gotoAndStop(5);
            }
        });

        this.on('pointerout', () => {
            if (this.isDisabled) {
                return;
            }
            if (!GameData.getProperty(this.checkingProp)) {
                this.gotoAndStop(0);
            } else {
                this.gotoAndStop(4);
            }
        });

        this.on('pointerdown', () => {
            if (this.isDisabled) {
                return;
            }
            if (!GameData.getProperty(this.checkingProp)) {
                this.gotoAndStop(3);
            } else {
                this.gotoAndStop(7);
            }
        });

        this.on('pointerup', () => {
            if (this.isDisabled) {
                return;
            }
            if (!GameData.getProperty(this.checkingProp)) {
                this.gotoAndStop(1);
            } else {
                this.gotoAndStop(5);
            }
        });

        const isChecked = GameData.getProperty(this.checkingProp);
        if (isChecked) {
            this.switchOn();
        } else {
            this.switchOff();
        }
    }
}

export default TurboButton;
